var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-tabs"},[_c('div',{staticClass:"tabs-controls"},_vm._l((_vm.tabs),function(ref,i){
var title = ref.title;
var disabled = ref.disabled;
return _c('button',{key:title || i,class:[{'is-active': _vm.activeTabIndex === i + 1}],attrs:{"disabled":disabled,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.handlerSelectTab(title)}}},[_vm._v(_vm._s(title))])}),0),_c('div',{staticClass:"tabs-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }